// 折扣值转换
// @params discount 折扣值 8.8
// @return 20%
const i18nConvertDiscount = (discount) => {
  const params = new URLSearchParams(window.location.href.split('?')[1]);
  const lang = params.get('lang') || 'zh-CN';
  // 根据语言类型确定折扣表达式格式
  if (lang === 'en-US') {
    const percentageOff = Math.round((100 - discount * 10) * 10) / 10; // 将折扣转换为百分比并保留一位小数
    return `${percentageOff}%`;
  }
  // 默认 zh-CN
  return discount;
};

export { i18nConvertDiscount };
